import React, { useContext } from 'react'
import { useParams } from 'react-router-dom'
import { FilterContext } from '../../Context/FilterContext'

const filterUrl = `https://zomatourl.herokuapp.com/filter`

const SortFilter = () => {
    const { setRestaurants } = useContext(FilterContext)
    const params = useParams();
    const mealId = params.id;

    const costfilter = (e) => {
        fetch(`${filterUrl}/${mealId}?sort=${e.target.value}`)
            .then(res => res.json())
            .then(data => {
                setRestaurants(data)
            })
            .catch(err => {
                console.log(err);
            })

    }
    return (
        <div className="sort mt-4" onChange={costfilter}>
            <h6>Cost For Two</h6>
            <div className="low-to-high">
                <label htmlFor="low-to-high" >
                    <input type="radio" name="sort" id="low-to-high" value="1" className='me-2' />
                    Low to High
                </label>
            </div>
            <div className="high-to-low">
                <label htmlFor="high-to-low" >
                    <input type="radio" name="sort" id="high-to-low" value="-1" className='me-2' />
                    High to Low
                </label>
            </div>
        </div>
    )
}

export default SortFilter;